"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("./lexus.css");
var _typography = require("../../packages/typography");
const sizings = {
  // display
  display84_100: "84px/100px",
  display72: "72px/72px",
  display64: "64px/64px",
  display60: "60px/62px",
  display60_60: "60px/60px",
  display55: "55px/58px",
  display50: "50px/58px",
  display48: "48px/48px",
  display45: "45px/48px",
  display36: "36px/42px",
  display30: "30px/32px",
  // heading
  heading50: "50px/60px",
  heading40: "40px/48px",
  heading36: "36px/42px",
  heading34: "34px/40px",
  heading30: "30px/40px",
  heading30_32: "30px/32px",
  heading30_24: "30px/24px",
  heading32: "32px/38px",
  heading32_40: "32px/40px",
  heading28: "28px/21px",
  heading28_27: "28px/27px",
  heading24: "24px/30px",
  heading24_28: "24px/28px",
  heading18: "18px/22px",
  // subheading
  subheading20: "20px/24px",
  subheading20_28: "20px/28px",
  subheading18: "18px/22px",
  subheading18_26: "18px/26px",
  subheading16: "16px/24px",
  subheading16_18: "16px/18px",
  subheading14: "14px/18px",
  subheading12: "12px/16px",
  // body
  body16: "16px/24px",
  body14: "14px/20px",
  body12: "12px/18px",
  // link
  link13: "13px/18px",
  link11: "11px/16px",
  link11_14: "11px/14px",
  link10: "10px/12px",
  // legal
  legal10: "10px/12px",
  legal9: "9px/20px",
  legal8: "8px/10px",
  // existing erroneous values
  button: "",
  bodyCopy1: "",
  bodyCopy2: ""
};
const aliases = {
  spacing: {
    wide: (0, _typography.trackingToLetterSpacing)(100)
  },
  weight: {
    light: "300",
    book: "400",
    regular: "500",
    bold: "700"
  }
};
const defaults = {
  spacing: (0, _typography.trackingToLetterSpacing)(40)
};
const config = {
  nobel: {
    sizings,
    aliases,
    defaults,
    family: "nobel"
  },
  pakt: {
    sizings,
    aliases,
    defaults,
    family: "pakt"
  },
  decimaMonoPro: {
    sizings: {
      ...sizings,
      // Here we are overriding the pixel values with custom properties
      // to provide more flexibility with responsive text sizing. If
      // needed, we can change these from a parent context/element since
      // the custom properties inherit.
      heading40: ["var(--heading-font-size, 40px)", "var(--heading-line-height, 48px)"].join("/")
    },
    aliases: {
      spacing: aliases.spacing,
      weight: {
        light: "300",
        regular: "400",
        bold: "700"
      }
    },
    defaults,
    family: "DecimaMonoPro, nobel"
  },
  akkuratMono: {
    sizings,
    aliases: {
      spacing: aliases.spacing,
      weight: {
        regular: "400"
      }
    },
    defaults,
    family: "akkurat-mono, pakt"
  }
};
var _default = exports.default = config;